// oxlint-disable consistent-function-scoping
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Layout } from '../components/Layout/Layout';
import { LinkProxy } from '../components/LinkProxy';
import { metaDataService } from '../domain/services/metaDataService';
import { schemaService } from '../domain/services/schemaService';
import { headService } from '../domain/services/headService';
import { eventService } from '../domain/services/eventService';

const processHead = content => {
  const contentMetaData = metaDataService.getContentMetaData(content);
  headService.title(contentMetaData.title);
  contentMetaData.meta.forEach(meta => headService.meta(meta));
  contentMetaData.link.forEach(link => headService.link(link));

  const schema = schemaService.getSchema(content);
  if (schema) {
    headService.script({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema)
    });
  }
};

const onTransporterRoutePreUpdate = event => {
  // Only reset headService during transporter updates
  headService.reset();
  processHead(event.detail.content);
};

const WithLayout = Component => {
  const wrapper = props => {
    const { content } = props.pageContext.node.data;
    processHead(content);

    useEffect(() => {
      eventService.addEventListener(
        'transporterRoutePreUpdate',
        onTransporterRoutePreUpdate,
        { setFlag: false }
      );

      return () =>
        eventService.removeEventListener(
          'transporterRoutePreUpdate',
          onTransporterRoutePreUpdate
        );
    }, []);

    return (
      <Layout content={content}>
        <Component content={content} />
        <LinkProxy />
      </Layout>
    );
  };

  wrapper.propTypes = {
    pageContext: PropTypes.objectOf(PropTypes.any).isRequired
  };
  return wrapper;
};

WithLayout.propTypes = {
  Component: PropTypes.element
};

// oxlint-disable-next-line no-default-export
export default WithLayout;
